import { useEffect, useState } from "react";
import client, { apiError } from "../../api/client";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";

const inputCls = "h-9 px-3 rounded-md border border-input bg-background text-sm outline-none focus:ring-2 focus:ring-ring/20";
const KEYS = [["", "—"], ["new", "Nový"], ["confirmed", "Potvrzený"], ["realized", "Realizovaný"], ["cancelled", "Zrušený"]];

export default function StatusesManager() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ name: "", color: "#3b82f6", key: "" });

  const load = () => client.get("/admin/statuses").then((res) => setItems(res.data));
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!form.name.trim()) return;
    try { await client.post("/admin/statuses", form); setForm({ name: "", color: "#3b82f6", key: "" }); load(); }
    catch (err) { toast.error(apiError(err)); }
  };
  const del = async (id) => {
    if (!window.confirm("Smazat stav?")) return;
    try { await client.delete(`/admin/statuses/${id}`); load(); } catch (err) { toast.error(apiError(err)); }
  };

  return (
    <div className="max-w-2xl">
      <h2 className="font-heading text-lg font-medium mb-4">Stavy workshopů</h2>
      <div className="flex gap-2 mb-4">
        <input value={form.name} onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))} placeholder="Název stavu" className={inputCls + " flex-1"} data-testid="status-name" />
        <input type="color" value={form.color} onChange={(e) => setForm((f) => ({ ...f, color: e.target.value }))} className="h-9 w-12 rounded-md border border-input" />
        <select value={form.key} onChange={(e) => setForm((f) => ({ ...f, key: e.target.value }))} className={inputCls} title="Systémový klíč">
          {KEYS.map((k) => <option key={k[0]} value={k[0]}>{k[1]}</option>)}
        </select>
        <button onClick={add} data-testid="status-add" className="h-9 px-4 rounded-md bg-primary text-primary-foreground text-sm font-medium hover:bg-primary/90 flex items-center gap-1"><Plus className="h-4 w-4" /> Přidat</button>
      </div>
      <div className="border border-border rounded-lg divide-y divide-border">
        {items.map((s) => (
          <div key={s.id} className="flex items-center gap-3 px-4 py-2.5" data-testid={`status-row-${s.id}`}>
            <span className="h-3 w-3 rounded-full" style={{ background: s.color }} />
            <span className="text-sm font-medium flex-1">{s.name}</span>
            <span className="text-xs text-muted-foreground">{KEYS.find((k) => k[0] === s.key)?.[1] || s.key}</span>
            <button onClick={() => del(s.id)} className="p-1.5 text-muted-foreground hover:text-destructive hover:bg-destructive/10 rounded"><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
